import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-spinner-svg',
  templateUrl: './spinner-svg.component.svg',
  styleUrls: ['./spinner-svg.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class SpinnerSvgComponent {}
